import { useEffect, useRef } from 'react';
import { webAssetUrl } from 'lib/utils/imageUtils';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { useRouter } from 'next/router';

const SportsSummit26 = () => {
  const router = useRouter();
  const sportsSummitCard = webAssetUrl('gss26/GSS26-Announcement-16x9.png');
  const isUpdatingFromMessage = useRef(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Only accept messages from the expected origin
      if (event.origin !== 'https://sportssummit.gondola.cc') {
        return;
      }
      // Check if the message contains navigation information
      if (event.data && typeof event.data === 'object' && event.data.type === 'navigation') {
        const { path } = event.data;

        if (typeof path === 'string') {
          // Remove leading slash and get the tab name
          const newTab = path === '/' ? undefined : path.replace(/^\//, '');
          const currentTab = undefined; // Index page has no tab

          // Only update if the path is different to avoid infinite loops
          if (newTab !== currentTab && !isUpdatingFromMessage.current) {
            isUpdatingFromMessage.current = true;

            if (newTab) {
              router.push(`/sportssummit26/${newTab}`, undefined, { shallow: true });
            } else {
              router.push('/sportssummit26', undefined, { shallow: true });
            }

            // Reset the flag after a short delay
            setTimeout(() => {
              isUpdatingFromMessage.current = false;
            }, 100);
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [router]);

  return (
    <>
      <GondolaHead
        title="Gondola Sports Summit 2026 | May 18-20 Denver"
        description="Join the premier sports media and creative professionals summit. May 18-20, 2026 at the Denver Art Museum, in Denver, CO. Tickets available now."
        url="https://sportssummit.gondola.cc"
        cardUrl={sportsSummitCard}
        image={sportsSummitCard}
      />
      <div className="relative overflow-hidden w-full h-full">
        <iframe
          src="https://sportssummit.gondola.cc/"
          title="Gondola Sports Summit 2026"
          className="absolute top-0 left-0 bottom-0 right-0 w-full h-full"
        />
      </div>
    </>
  );
};

export default SportsSummit26;
